import React, { useEffect, useState } from "react";
import {
  getAdmins,
  createAdmin,
  updateAdminRole,
  deleteAdmin,
} from "../services/adminService";

const AdminUsersPage = () => {
  const [admins, setAdmins] = useState([]);
  const [newAdmin, setNewAdmin] = useState({ email: "", password: "", role: "admin" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchAdmins = async () => {
    try {
      setLoading(true);
      const data = await getAdmins();
      setAdmins(data);
    } catch (err) {
      setError("Помилка при завантаженні адміністраторів");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAdmins();
  }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      await createAdmin(newAdmin);
      setNewAdmin({ email: "", password: "", role: "admin" });
      fetchAdmins();
    } catch {
      setError("Не вдалося створити адміністратора");
    }
  };

  const handleRoleChange = async (id, role) => {
    await updateAdminRole(id, role);
    fetchAdmins();
  };

  const handleDelete = async (id) => {
    if (window.confirm("Видалити адміністратора?")) {
      await deleteAdmin(id);
      fetchAdmins();
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-semibold mb-4">Керування адміністраторами</h2>

      {/* Форма створення */}
      <form onSubmit={handleCreate} className="mb-6 space-y-2" autoComplete="off">
        <input
          type="email"
          placeholder="Email"
          value={newAdmin.email}
          onChange={(e) => setNewAdmin({ ...newAdmin, email: e.target.value })}
          required
          className="border p-2 rounded w-full"
          autoComplete="off" 
        />
        <input
          type="password"
          placeholder="Пароль"
          value={newAdmin.password}
          onChange={(e) => setNewAdmin({ ...newAdmin, password: e.target.value })}
          required
          className="border p-2 rounded w-full"
          autoComplete="new-password"
        />
        <select
          value={newAdmin.role}
          onChange={(e) => setNewAdmin({ ...newAdmin, role: e.target.value })}
          className="border p-2 rounded w-full"
        >
          <option value="admin">Адміністратор</option>
          <option value="superadmin">Супер-адміністратор</option>
        </select>
        <button
          type="submit"
          className="bg-[#4A3B30] text-white px-4 py-2 rounded hover:bg-[#3A2C23]"
        >
          Додати
        </button>
      </form>

      {loading ? (
        <p>Завантаження...</p>
      ) : error ? (
        <p className="text-red-500">{error}</p>
      ) : (
        <table className="w-full border">
          <thead className="bg-[#EFEAE4]">
            <tr>
              <th className="border p-2">ID</th>
              <th className="border p-2">Email</th>
              <th className="border p-2">Роль</th>
              <th className="border p-2">Дії</th>
            </tr>
          </thead>
          <tbody>
            {admins.map((admin) => (
              <tr key={admin.id} className="text-center">
                <td className="border p-2">{admin.id}</td>
                <td className="border p-2">{admin.email}</td>
                <td className="border p-2">{admin.role}</td>
                <td className="border p-2 space-x-2">
                  <select
                    value={admin.role}
                    onChange={(e) => handleRoleChange(admin.id, e.target.value)}
                    className="border p-1 rounded"
                  >
                    <option value="admin">admin</option>
                    <option value="superadmin">superadmin</option>
                  </select>
                  <button
                    onClick={() => handleDelete(admin.id)}
                    className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                  >
                    Видалити
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AdminUsersPage;
